import { useEffect, useState } from 'react';
import { useSubscription } from '@/hooks/useSubscription';
import { useNavigate } from 'react-router-dom';

export default function SuccessPage() {
  const { checkSubscription } = useSubscription();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    // IMPL-10: Show processing state initially, then auto-redirect
    const handleSuccess = async () => {
      await checkSubscription(true); // Force refresh subscription status
      
      // Wait a moment for webhook processing
      setTimeout(() => {
        setIsProcessing(false);
        
        // Auto-redirect after 5 seconds
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }, 2000);
    };

    handleSuccess();
  }, [checkSubscription, navigate]);

  if (isProcessing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <h1 className="text-xl font-semibold mb-2">Processing Payment...</h1>
          <p className="text-muted-foreground">Please wait while we confirm your subscription.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-app-background">
      <div className="p-8 max-w-xl mx-auto text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-semibold mb-2">Payment Successful!</h1>
        <p className="text-muted-foreground mb-4">
          Your subscription is now active. You'll be redirected to the main app in a few seconds.
        </p>
        <p className="text-sm text-gray-500">
          You can safely close this tab or wait for automatic redirect.
        </p>
      </div>
    </div>
  );
}

